import csTools from "cornerstone-tools";
import { BRUSH_COLOR, BRUSH_BASE_COLOR } from "./colors-for-brush";
const external = csTools.external;

import getTinyBrushMixin from "./get-tiny-brush-mixin";

/**
 * Called by the event dispatcher to render the image.
 *
 * @param {Object} evt - The event.
 * @returns {void}
 */
function renderBrush(evt) {
  const eventData = evt.detail;
  const elementId = eventData.element.id;
  const selectedViewerId =
    window.angular?.stateManagerProjectService?.getSelectedViewerId() ??
    elementId;

  if (selectedViewerId !== elementId) {
    return;
  }

  const { cornerstone } = external;
  const viewport = eventData.viewport;

  let mousePosition;

  if (this._drawing) {
    mousePosition = this._lastImageCoords;
  } else if (this._mouseUpRender) {
    mousePosition = this._lastImageCoords;
    this._mouseUpRender = false;
  } else {
    mousePosition = csTools.store.state.mousePositionImage;
  }

  if (!mousePosition) {
    return;
  }

  const { rows, columns } = eventData.image;
  const { x, y } = mousePosition;

  if (x < 0 || x > columns || y < 0 || y > rows) {
    return;
  }

  // Draw the hover overlay on top of the pixel data
  const radius = csTools.getModule("segmentation").configuration.radius;
  const context = eventData.canvasContext;
  const element = eventData.element;
  const color = BRUSH_BASE_COLOR;

  context.setTransform(1, 0, 0, 1, 0, 0);

  const widthOfCircle = radius * viewport.scale;
  const mouseCoordsCanvas = cornerstone.pixelToCanvas(element, mousePosition);
  const xCoords = mouseCoordsCanvas.x;
  const yCoords = mouseCoordsCanvas.y;

  context.beginPath();

  context.lineWidth = 1;
  context.strokeStyle = color;
  if (radius == 1) {
    const widthOfRect =
      rows < columns || rows == columns
        ? widthOfCircle
        : widthOfCircle * (eventData.image.columnPixelSpacing / eventData.image.rowPixelSpacing);
    const heightOfRect =
      rows > columns || rows == columns
        ? widthOfCircle
        : widthOfCircle * (eventData.image.rowPixelSpacing / eventData.image.columnPixelSpacing);
    getTinyBrushMixin(context, widthOfRect, heightOfRect, xCoords, yCoords, BRUSH_COLOR);
  } else {
    context.ellipse(
      xCoords,
      yCoords,
      widthOfCircle,
      widthOfCircle,
      0,
      0,
      2 * Math.PI
    );
    context.stroke();
  
    context.beginPath();
  
    const widthOfSecondCircle = widthOfCircle * 0.2 < 3 ? widthOfCircle * 0.2 : 3;
  
    context.lineWidth = widthOfSecondCircle;
    context.strokeStyle = `rgba(${BRUSH_COLOR.join()}, 1)`;
    context.ellipse(
      xCoords,
      yCoords,
      widthOfCircle - widthOfSecondCircle + 1,
      widthOfCircle - widthOfSecondCircle + 1,
      0,
      0,
      2 * Math.PI
    );
    context.stroke();
  
    context.beginPath();
  
    context.ellipse(
      xCoords,
      yCoords,
      widthOfCircle - widthOfSecondCircle * 2 + 2,
      widthOfCircle - widthOfSecondCircle * 2 + 2,
      0,
      0,
      2 * Math.PI
    );
    context.fillStyle = `rgba(${BRUSH_COLOR.join()}, 0.25)`;
  }
  context.fill();
}

/**
 * @mixin polygonSegmentationMixin - segmentation operations for polyline
 * @memberof Mixins
 */
export default {
  renderBrush,
};
